module.exports = __webpack_public_path__ + "img/8.a130aea1.png";